import './MainNav.scss';
import Component from './MainNav.js';
import ReactiveWrapper from '../ReactiveWrapper';
export default ReactiveWrapper(Component);